<template>
    <a
        href="#"
        class="featured-icon"
        @click.prevent="setFeatured"
    >
        <i :class="[featured ? 'fas' : 'fal', iconClass, 'fa-star']" />
    </a>
</template>

<script>
import { mapActions } from 'vuex';
import toasts from '@/mixins/toasts';

export default {
    mixins: [
        toasts,
    ],

    props: {
        trackNo: {
            type: String,
            default: '1:0',
        },
        playerFeatured: {
            type: Boolean,
            default: false,
        },
        show: {
            type: Object,
            required: true,
        },
        iconClass: {
            type: String,
            default: '',
        },
    },

    data: () => ({
        featured: false,
    }),

    watch: {
        playerFeatured: {
            immediate: true,

            /**
             *
             * @param   {boolean}  featured  Is player featured
             *
             */
            handler(featured) {
                this.featured = featured;
            },
        },
    },

    methods: {
        ...mapActions(['setEpisodeFeaturedStatus']),

        /**
         * Sets episode featured value
         *
         */
        async setFeatured() {
            this.featured = ! this.featured;

            try {
                this.setEpisodeFeaturedStatus({
                    type: 'track',
                    showHash: this.show.hash,
                    trackNo: this.trackNo,
                    featured: this.featured,
                });
            } catch (e) {
                this.featured = ! this.featured;

                this.toastError({
                    message: {
                        title: 'We couldn\'t set your episode as featured. Please try again later or contact us.',
                    },
                });
            }
        },
    },
};
</script>
